/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { APP_VERSION } from '../lib/config.js';
import * as store from '../lib/store.js';

export default {
  stopProp(e) { return e.stopPropagation(); },

  closeDialog() { return this.setState({ dialog: null }); },

  openWelcome() { return this.setState({ welcome: true, notifOpen: false }); },

  /** Het leaderbord: een venster, dus een eigen vlag en naar voren halen. */
  openActivity() {
      this.vensterNaarVoren('activity');
      return this.setState({ activityOpen: true, vensterMin: Object.assign({}, this.state.vensterMin, { activity: false }), notifOpen: false, startOpen: false });
    },

  closeActivity() { return this.setState({ activityOpen: false, vensterMin: Object.assign({}, this.state.vensterMin, { activity: false }) }); },

  toggleNotif() {
      const opening = !this.state.notifOpen;
      if (opening) store.set('gp_notif_seen_' + APP_VERSION, '1');
      this.setState({ notifOpen: opening, notifUnseen: opening ? false : this.state.notifUnseen, notifLimit: opening ? 15 : this.state.notifLimit, chatOpen: opening ? false : this.state.chatOpen, dialog: opening && this.state.dialog === 'account' ? null : this.state.dialog });
    }
};
